<div
  class="app-card-widget w-100 h-100 d-flex flex-column"
  style="overflow: auto"
  [ngStyle]="{ 'background-color': backgroundColor }"
>
  <div class="card-header-widget">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex">
        <h3 class="title mr-2">{{ title }}</h3>
        <button
          [matTooltip]="swapTooltip"
          class="button-swap"
          *ngIf="hasButtonSwap"
          (click)="handleClick()"
        >
          <mat-icon style="font-size: 16px">swap_vert</mat-icon>
        </button>
      </div>
      <div *ngIf="!repId || repId == identity.sub" class="d-flex">
        <button
          *ngIf="filters?.length || notes"
          class="icon-button"
          (click)="onMoreClick()"
          aria-label="More options"
          [matMenuTriggerFor]="!notes ? filterMenu : ''"
        >
          <mat-icon class="icon-small">{{ iconBtn }}</mat-icon>
        </button>
        <button
          *ngIf="noteId && iconBtn == 'edit'"
          class="icon-button"
          (click)="removeNote()"
        >
          <mat-icon class="icon-small">delete</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="labelTime" class="card-subheader">
    <span class="label">{{ getFilterLabel(labelTime) }}</span>
  </div>
  <!-- <mat-menu *ngFor="let filter of filters; index as i" #filterMenu="matMenu"> -->
  <mat-menu #filterMenu="matMenu">
    <button
      *ngFor="let filter of filters; index as i"
      mat-menu-item
      (click)="onFilterChange(filter)"
    >
      {{ getFilterLabel(filter) }}
    </button>
  </mat-menu>
  <div class="card-content d-flex flex-column justify-content-between h-100">
    <p class="qty mt-3" *ngIf="qty"><span *ngIf="isMoney">$</span> {{ qty }}</p>
    <div class="d-flex h-100" style="min-height: 150px" *ngIf="notes">
      <textarea
        *ngIf="iconBtn == 'save'; else noteBlock"
        class="notes-textarea w-100 h-100"
        [(ngModel)]="note"
        name="note"
        placeholder="Write personal notes here..."
        id=""
      ></textarea>
      <ng-template #noteBlock>
        <p
          class="w-100 pt-0"
          style="font-weight: normal; white-space: pre-wrap"
        >
          {{ note }}
        </p>
      </ng-template>
    </div>
    <div *ngIf="hasPercentage" class="progress-container">
      <div class="progress-circle" style="width: 150px" id="chart">
        <apx-chart
          [series]="chartSeries"
          [chart]="chartDetails.chart"
          [plotOptions]="chartDetails.plotOptions"
          [fill]="chartDetails.fill"
          [stroke]="chartDetails.stroke"
          [legend]="chartDetails.legend"
          [dataLabels]="chartDetails.dataLabels"
        ></apx-chart>
      </div>
    </div>
    <div *ngIf="list" class="reminders-container">
      <div class="table-header">
        <span class="col-completed">Done</span>
        <span class="col-date">Date</span>
        <span class="col-hour">Hour</span>
        <span class="col-description">Description</span>
      </div>
      <p style="padding: 4px; background-color: #f0f0f0" *ngIf="!data?.length">
        No Data
      </p>
      <ul class="table-body">
        <li *ngFor="let element of data" class="table-row">
          <mat-checkbox
            class="col-completed reminder-col"
            (change)="onCheckboxChange(element.id)"
            [ngModel]="element.completed"
            [checked]="element.completed === 1"
          >
          </mat-checkbox>
          <span class="col-date reminder-col">{{
            element.fecha | date : "MM/dd/yyyy"
          }}</span>
          <span class="col-hour reminder-col">{{ element.hora }}</span>
          <span class="col-description reminder-col">{{
            element.descripcion
          }}</span>
        </li>
      </ul>
    </div>
    <!-- <div
      class="d-flex gap-4 align-items-center justify-content-around"
      *ngIf="avatar"
    >
      <app-avatar
        [avatarSize]="'large'"
        [starRate]="true"
        *ngFor="let avatar of avatars; let i = index"
        [position]="i + 1"
        [name]="avatar.name"
        backgroundImg="https://t3.ftcdn.net/jpg/02/99/04/20/360_F_299042079_vGBD7wIlSeNl7vOevWHiL93G4koMM967.jpg"
      ></app-avatar>
    </div> -->
    <div *ngIf="topThree.length > 0 && avatar" class="avatar-container">
      <div
        *ngFor="let buyer of topThree; let i = index"
        [ngClass]="getAvatarPosition(i)"
      >
        <app-avatar
          [starRate]="true"
          [position]="i + 1"
          class="mr-2"
          [name]="fullName(buyer.buyer?.name, buyer.buyer?.surname)"
          [profit]="
            isDashAdmin && buyer.profit ? (buyer.profit | formatNumber) : ''
          "
          [backgroundImg]="buyer.buyer?.avatarUrl"
          [avatarSize]="i == 0 ? 'large' : 'mid'"
        ></app-avatar>
      </div>
    </div>

    <div
      *ngIf="!list && displayedColumns?.length > 0"
      class="h-100 d-flex flex-column justify-content-between"
    >
      <table
        mat-table
        [dataSource]="filteredData"
        [ngStyle]="{ 'background-color': backgroundColor }"
      >
        <ng-container
          *ngFor="let column of displayedColumns"
          [matColumnDef]="column.key"
        >
          <th
            style="color: #636363; font-weight: normal"
            mat-header-cell
            *matHeaderCellDef
          >
            <ng-container>
              {{ column.header }}
            </ng-container>
          </th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="column.key === 'buyer'; else normalColumn">
              <div class="d-flex align-items-center">
                <app-avatar
                  class="mr-2"
                  [backgroundImg]="element.buyer?.avatarUrl"
                  [avatarSize]="'small'"
                ></app-avatar>
                <span class="buyer-name">
                  {{ element.buyer?.name }} {{ element.buyer?.surname }}
                </span>
              </div>
            </ng-container>

            <ng-template #normalColumn>
              <ng-container *ngIf="column.key === 'cost'">
                {{ element.item?.cost || element.cost | currency }}
              </ng-container>
              <ng-container *ngIf="column.key === 'profit'">
                {{ element.profit | formatNumber }}
              </ng-container>
              <ng-container
                *ngIf="column.key === 'poline' || column.key === 'po'"
              >
                <div
                  class="hyperlink"
                  (click)="getPo(element.item?.poline, element.po, $event)"
                >
                  {{ element.item?.poline || element.po }}
                </div>
              </ng-container>

              <ng-container *ngIf="column.key === 'item'">
                {{ element.item?.name }}
              </ng-container>

              <ng-container
                *ngIf="
                  column.key !== 'buyer' &&
                  column.key !== 'cost' &&
                  column.key !== 'profit' &&
                  column.key !== 'po' &&
                  column.key !== 'item'
                "
              >
                {{ element[column.key] }}
              </ng-container>
            </ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="filteredColumnsKeys"></tr>
        <tr
          [class.hasPoline]="row.item"
          (click)="row.item ? getItem(row.id) : null"
          mat-row
          *matRowDef="let row; columns: filteredColumnsKeys"
        ></tr>
      </table>
      <mat-paginator
        *ngIf="data?.length > 0 && pagination"
        #paginator
        [pageSize]="items_per_page"
        [length]="total_items_count"
        [pageIndex]="page_actual ? page_actual - 1 : 0"
        (page)="onPaginatorChange($event)"
      >
      </mat-paginator>
      <p
        style="padding: 4px; background-color: #f0f0f0"
        *ngIf="!data?.length && !qty && !hasPercentage && !notes && !list"
      >
        No Data
      </p>
    </div>
    <div
      *ngIf="lastUpdate"
      style="
        color: #898989;
        font-weight: normal;
        font-size: 12px;
        line-height: 1rem;
        text-align: center;
        align-self: flex-end;
        margin-top: 1rem;
        width: 100%;
        display: flex;
        align-items: end;
        height: 100%;
        justify-content: center;
      "
    >
      Last Update: {{ formatLastUpdate(lastUpdate) }}
    </div>
  </div>
</div>
